<template>
  <div class="company-manager-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-office-building"></i> Companys</span>
        <el-button
          icon="el-icon-plus"
          v-if="!readonlyMode"
          style="float: right; padding: 0"
          type="text"
          @click="selectVenderType()"
          >Create Company</el-button
        >
      </div>
      <div class="table-data-company">
        <data-tables
          v-loading="loadingCompany"
          :data="dataCompanyTable"
          border
          :page-size="10"
          :pagination-props="{
            background: true,
            pageSizes: [5, 10, 20, 50, 100],
          }"
        >
          <el-table-column
            prop="company_name"
            label="Company"
            header-align="center"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            prop="website"
            label="Website"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="email_contact"
            label="Email Contact"
            header-align="center"
            align="center"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="phone_number"
            label="Phone Number"
            header-align="center"
            align="center"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="status"
            label="Staus"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status === 'active' ? 'success' : 'danger'"
                >{{ scope.row.status }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="created_date"
            label="Created"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="updated_date"
            label="Updated"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="uid"
            label="Action"
            header-align="center"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-circle-check"
                @click="$router.push('/company/info/' + scope.row.uid)"
                >View</el-button
              >
              <el-button
                type="warning"
                v-if="!readonlyMode"
                size="mini"
                icon="el-icon-edit"
                @click="$router.push('/company/edit/' + scope.row.uid)"
                >Edit</el-button
              >
              <el-button
                type="danger"
                v-if="!readonlyMode"
                size="mini"
                icon="el-icon-delete"
                @click="deleteCompany(scope.row.uid)"
                >Del</el-button
              >
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </el-card>

    <el-dialog
  title="Please select vender type"
  :visible.sync="dialogFormVisible"
  width="30%"
  center>
  <div class="text-center">
    <el-select v-model="venderType" placeholder="Select vender type">
      <el-option label="Railbank" value="railbank"></el-option>
      <el-option label="Modulr" value="modulr"></el-option>
    </el-select>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">Cancel</el-button>
    <el-button type="primary" @click="gotoCreateCompany()">Confirm</el-button>
  </span>
</el-dialog>
 
  </div>
</template>

<script>
import {
  getCompany,
  delCompany
} from "@/api/company";

import { getUtility } from "@/api/customer";

export default {
  props: {
    readonlyMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      loadingCompany: false,
      dataCompanyTable: [],
      dialogFormVisible: false,
      venderType: "railbank",
    };
  },
  methods: {
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.utility = data;
        }
      });
    },
    getCompanyData() {
      this.loadingCompany = true;
      getCompany().then(({ result, data }) => {
        this.loadingCompany = false;
        if (result && data) {
          this.dataCompanyTable = data;
        }
      });
    },

    selectVenderType(){
      this.dialogFormVisible = true;
    },

    gotoCreateCompany(){
      this.$router.push(`/company/create/${this.venderType}`);
    },
    deleteCompany(uid) {
      this.$confirm(
        "Are you sure you want to close this Company, Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          delCompany(uid).then(({ result, message }) => {
            if (result) {
              this.$notify({
                title: "Success",
                message: `Delete Company successfully`,
                type: "success",
                duration: 2000
              });
              this.getCompanyData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },

    onSubmited(){
      this.getCompanyData();
    }

  },
  created() {
    this.getUtility();
    this.getCompanyData();
  },
};
</script>

<style lang="scss">

</style>